<template>
  <div class="no-print" v-on-clickaway="clickaway">
    <div class="sidebar-nav">
      <div class="nav">
        <div class="docendo-logo box-shadow"
             v-if="userHasPermission('can_see_other_calendars') || (userHasMultipleSchools && !userHasPermission('can_see_other_calendars'))">
          <span class="docendo-logo__icon icon-docendo" v-show="open === false" @click="openSideNav(0)"></span>
          <div class="icon-cross2 font-large" style="padding: 18px" v-show="open === true" @click="closeSideNav"></div>
        </div>
        <div class="docendo-logo docendo-logo__not-active box-shadow"
             v-if="!userHasPermission('can_see_other_calendars') && !userHasMultipleSchools">
          <span class="docendo-logo__icon icon-docendo"></span>
        </div>
        <ul @click="openSideNav" v-if="userHasPermission('can_see_other_calendars') && activeSchool">
          <li @click.stop="goToDutySchedule" v-if="isKindergarten">
            <div class="icons icon-users5 gtm"
                 data-gtm="SideNav__club"></div>
            Vagtplan
          </li>
          <li class="js-intro js-intro-sidebar-nav__kindergarten gtm"
              :class="{active: isActive(7)}"
              @click="chooseCals(7)"
              data-gtm="SideNav__club"
              v-if="isKindergarten">
            <div class="icons icon-users5 gtm"
                 data-gtm="SideNav__club"></div>
            Stuer
          </li>
          <li
            v-if="!isKindergarten"
            class="js-intro js-intro-sidebar-nav__klass gtm test-2"
            :class="{active: isActive(1)}"
            @click="chooseCals(1)"
            data-gtm="SideNav__klass">
            <div class="icons icon-calendar4 gtm" data-gtm="SideNav__klass"></div>
            {{ $t('vue2.common.classes_sidenav') }}
          </li>
          <li class="js-intro js-intro-sidebar-nav__users gtm"
              :class="{active: isActive(2)}"
              @click="chooseCals(2)"
              data-gtm="SideNav__users">
            <div class="icons icon-users gtm"
                 data-gtm="SideNav__users"></div>
            {{ $t('vue2.common.users') }}
          </li>
          <li class="js-intro js-intro-sidebar-nav__location gtm"
              :class="{active: isActive(3)}"
              @click="chooseCals(3)"
              data-gtm="SideNav__location">
            <div class="icons icon-location gtm"
                 data-gtm="SideNav__location"></div>
            {{ $t('vue2.common.rooms') }}
          </li>
          <li class="js-intro js-intro-sidebar-nav__merge gtm"
              v-if="!isKindergarten"
              :class="{active: isActive(4)}"
              @click="chooseCals(4)"
              data-gtm="SideNav__merge">
            <div class="icons icon-calendar-week gtm"
                 data-gtm="SideNav__merge"></div>
            {{ $t('vue2.common.merge_calendars_sidenav') }}
          </li>
          <li class="js-intro js-intro-sidebar-nav__other gtm"
              :class="{active: isActive(5)}"
              @click="chooseCals(5)"
              data-gtm="SideNav__other">
            <div class="icons icon-clipboard2 gtm"
                 data-gtm="SideNav__other"></div>
            {{ $t('vue2.common.other_calendars') }}
          </li>
          <li class="js-intro js-intro-sidebar-nav__club gtm"
              :class="{active: isActive(6)}"
              @click="chooseCals(6)"
              data-gtm="SideNav__club"
              v-if="isSchoolSFOActive && !isKindergarten">
            <div class="icons icon-users5 gtm"
                 data-gtm="SideNav__club"></div>
            {{ $t('vue2.club.club') }}
          </li>
        </ul>
      </div>
    </div>
    <div class="sidebar-nav__container" :class="[{sidebar_nav_container_show: open}]">
      <div class="sidebar-nav__container__header box-shadow flex">
        <div class="flex flex-vertical-center" style="width:85%">
          <h2>
            <a v-if="activeSchool" class="link-white" :href="'/schools/' + activeSchool.id">{{ activeSchool.name }}</a>
          </h2>
        </div>
        <span class="icon-arrow-down5 arrow-dropdown"
              :class="{active: changeSchoolDropdown}"
              @click="toggleChangeSchoolDropdown"></span>
        <div v-if="changeSchoolDropdown"
             class="sidebar-nav__container--dropdown bg-light-blue box-shadow pos-absolute z-index-1000 text-white width-100 box-sizing">
          <list-with-search
            :selected="activeSchool"
            :options="allSchools"
            @choose="toggleChangeSchoolDropdown">
          </list-with-search>
        </div>
      </div>

      <template v-if="!isLoading && yearCals.length < 1">
        <div class="no-cals">
          <div class="no-cals__icon">
            <span :class="activeType.icon"></span>
          </div>
          <p class="no-cals__text" v-html="notCreatedAnyTextString"></p>
        </div>
      </template>

      <div class="create-link__container">
        <a @click.prevent="createKlasses"
           v-if="isActive(1) && userHasPermission('can_manage_calendars')"
           class="create-cal__button">+ {{ $t('vue2.common.create') }} <span class="lowercase">{{
            activeType.title
          }}</span>
          <onboardArrow v-if="activeOnboardingStep === 1 && showOnboardingArrow"></onboardArrow>
        </a>
        <a @click.prevent="createUsers"
           v-if="isActive(2) && userHasPermission('can_manage_users')"
           class="create-cal__button">+ {{ $t('vue2.common.create') }} <span class="lowercase">{{
            activeType.title
          }}</span>
          <onboardArrow v-if="activeOnboardingStep === 2 && showOnboardingArrow"></onboardArrow>
        </a>
        <a @click.prevent="createCalendars(activeType.type)"
           v-if="isActive(3) && userHasPermission('can_manage_calendars')"
           class="create-cal__button">+ {{ $t('vue2.common.create') }} <span class="lowercase">{{
            activeType.title
          }}</span>
          <onboardArrow v-if="activeOnboardingStep === 3 && showOnboardingArrow"></onboardArrow>
        </a>
        <a @click.prevent="createCalendars(activeType.type)"
           v-if="isActive(4) && userHasPermission('can_manage_calendars')"
           class="create-cal__button">+ {{ $t('vue2.common.create') }} <span class="lowercase">{{
            activeType.title
          }}</span>
          <onboardArrow v-if="activeOnboardingStep === 4 && showOnboardingArrow"></onboardArrow>
        </a>
        <a @click.prevent="createCalendars(activeType.type)"
           v-if="(isActive(5) || isActive(6) || isActive(7) ) && userHasPermission('can_manage_calendars')"
           class="create-cal__button">+ {{ $t('vue2.common.create') }} <span class="lowercase">{{
            activeType.title
          }}</span>
        </a>
      </div>
      <ChangeSchoolYear style="margin: 10px 15px 0;"
                        v-if="activeType.hasSchoolYear"></ChangeSchoolYear>
      <div class="sidebar-nav__search" v-if="!isLoading && yearCals.length > 0">
        <input type="text" v-model="search" :placeholder="$t('vue2.common.search_for') + ' ' + searchName"
               id="searchfield" ref="searchfield"/>
        <span @click="clearSearch" v-show="search !== ''" class="sidebar-nav__search__cross pointer icon-cross2"></span>
      </div>
      <div class="sidebar-nav__container__body" v-if="userHasPermission('can_see_other_calendars')">
        <div v-if="isLoading" style="margin-top: 100px">
          <Loader bg-color="#3e4450"></Loader>
        </div>
        <template v-else>
          <ul class="nav__cal-list">
            <li v-for="cal in searchCals" :key="cal.id">
              <template v-if="cal.type !== 'klass'">
                <a v-if="userHasPermission('can_do_most_stuff')" :href="cal.url">{{
                    cal.name ? cal.name : cal.url
                  }}</a>
                <a v-else @click.prevent="setActiveCalendarId(cal.id)">{{ cal.name ? cal.name : cal.url }}</a>
              </template>
              <div class="nav__cal-list__item" v-if="cal.type === 'klass'"
                   :class="{'nav__cal-list__item--open': isStudentsActiveForCal(cal.id)}">
                <a v-if="userHasPermission('can_do_most_stuff')" :href="cal.url">{{
                    cal.name ? cal.name : cal.url
                  }}</a>
                <a v-else @click.prevent="setActiveCalendarId(cal.id)">{{ cal.name ? cal.name : cal.url }}</a>
                <div @click="setTheStudentsActiveForCal(cal.id)" v-if="cal.students && cal.students.length > 0">
                  <span class="icon-arrow-down52"></span>
                </div>
              </div>
              <ul class="nav__cal-list__item__students" v-if="isStudentsActiveForCal(cal.id)">
                <li v-for="student in getCalStudents(cal.students)">
                  <a v-if="userHasPermission('can_do_most_stuff')" :href="student.url">{{
                      student.name ? student.name : student.url
                    }}</a>
                  <a v-else @click.prevent="setActiveCalendarId(student.id)">{{
                      student.name ? student.name : student.url
                    }}</a>
                </li>
              </ul>
            </li>
          </ul>
        </template>
      </div>
    </div>
    <TeamCalendar v-if="userHasPermission('can_see_other_calendars') && activeSchool"></TeamCalendar>
  </div>
</template>

<script>
import yearToggle from './common/ToggleYear.vue'
import {mixin as clickaway} from 'vue-clickaway'
import eventbus from '../eventbus'
import onboardArrow from './onboarding/OnboardArrow'
import ChangeSchoolYear from './School/ChangeSchoolYear'
import TeamCalendar from './TeamCalendar/TeamCalendar'
import moment from 'moment'
import Loader from './common/Loader'

export default {
  components: {Loader, yearToggle, onboardArrow, ChangeSchoolYear, TeamCalendar},
  mixins: [clickaway],
  data () {
    return {
      open: false,
      search: '',
      type: '',
      active: '',
      changeSchoolDropdown: false,
      searchName: '',
      hover: false,
      theStudentsActiveForCal: null
    }
  },
  watch: {
    schoolId (val, oldVal) {
      this.getSchoolCalendars()
    },
    user () {
      this.setActiveSchool()
      this.$i18n.locale = this.locale
      moment.locale(this.locale)
      this.getSchoolCalendars()
    },
    activeOnboardingStep () {
      if (this.activeOnboardingStep > 0 && this.activeOnboardingStep < 5) {
        this.openSideNav()
        this.chooseCals(this.activeOnboardingStep)
      } else if (this.activeOnboardingStep === 6) {
        this.openSideNav()
        this.chooseCals(1)
      }
    }
  },
  computed: {
    isUserLoaded () {
      return this.$store.state.isUserLoaded
    },
    user () {
      return this.$store.state.user
    },
    locale () {
      return this.$store.getters.locale
    },
    schoolId () {
      if (this.$route && this.$route.params && this.$route.params.school_id) {
        return this.$route.params.school_id
      }
      if (this.activeSchool && this.activeSchool.id) {
        return this.activeSchool.id
      }
      if (window.SCHOOL && window.SCHOOL.id) {
        return window.SCHOOL.id
      }
    },
    isKindergarten () {
      return this.$store.getters.isKindergarten
    },
    isSchoolTestingStudents () {
      return this.$store.getters.isSchoolTestingStudents
    },
    isPermissionsActivatedForSchool () {
      return this.$store.getters.isPermissionsActivatedForSchool
    },
    userPermissions () {
      return this.$store.getters.userPermissions
    },
    userHasMultipleSchools () {
      return this.user && this.user.schools ? this.user.schools.length > 1 : false
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    year () {
      return this.activeSchoolYear.name
    },
    schoolYearStartDate () {
      return this.activeSchoolYear ? this.activeSchoolYear.student_time_start : null
    },
    notCreatedAnyTextString () {
      switch (this.activeType.type) {
        case 'klass':
          return this.$t('vue2.sidenav.not_created_klass')
        case 'user':
          return this.$t('vue2.sidenav.not_created_users')
        case 'room':
          return this.$t('vue2.sidenav.not_created_rooms')
        case 'merge':
          return this.$t('vue2.sidenav.not_created_merge')
        case 'other':
          return this.$t('vue2.sidenav.not_created_other')
        case 'club':
          return this.$t('vue2.club.not_created_club')
        case 'kindergarten':
          return 'stue'
      }
    },
    activeSchool () {
      return this.$store.state.activeSchool
    },
    cals () {
      return this.$store.state.calendars
    },
    isLoading () {
      return this.$store.state.isLoadingSchoolCalenders
    },
    activeOnboardingStep () {
      return this.$store.state.onboardingStep
    },
    showOnboardingArrow () {
      return eventbus.showOnboardingArrow
    },
    calendarData () {
      return {
        1: {
          type: 'klass',
          title: this.$i18n.t('vue2.common.class'),
          searchName: this.$i18n.t('vue2.common.classes'),
          icon: 'icon-calendar4',
          hasSchoolYear: true
        },
        2: {
          type: 'user',
          title: this.$i18n.t('vue2.common.user'),
          searchName: this.$i18n.t('vue2.common.users'),
          icon: 'icon-users',
          hasSchoolYear: false
        },
        3: {
          type: 'room',
          title: this.$i18n.t('vue2.common.room'),
          searchName: this.$i18n.t('vue2.common.rooms'),
          icon: 'icon-location',
          hasSchoolYear: false
        },
        4: {
          type: 'merge',
          title: this.$i18n.t('vue2.common.merge_calendar'),
          searchName: this.$i18n.t('vue2.common.merge_calendars'),
          icon: 'icon-calendar-week',
          hasSchoolYear: true
        },
        5: {
          type: 'other',
          title: this.$i18n.t('vue2.common.other_calendar'),
          searchName: this.$i18n.t('vue2.common.other_calendars'),
          icon: 'icon-clipboard2',
          hasSchoolYear: true
        },
        6: {
          type: 'club',
          title: this.$i18n.t('vue2.club.club_calendar'),
          searchName: this.$i18n.t('vue2.club.club'),
          icon: 'icon-users5',
          hasSchoolYear: true
        },
        7: {
          type: 'kindergarten',
          title: 'Stue',
          searchName: 'Stue',
          icon: 'icon-users5',
          hasSchoolYear: true
        }
      }
    },
    activeType () {
      if (this.active !== '') {
        return this.calendarData[this.active]
      } else {
        return ''
      }
    },
    allSchools () {
      return this.user.schools
    },
    activeCals () {
      return this.cals.filter(cal => cal.type === this.type && !cal.archived_at)
    },
    yearCals () {
      const cals = this.activeCals.filter(cal => {
        // Schoolyears didn't have id before 2020
        return cal.school_year_id ? cal.school_year_id === this.activeSchoolYear.id : cal.year === '' || cal.year.match(this.year)
      })
      return this.$helpers.sortArrOnName(cals)
    },
    searchCals () {
      return this.yearCals.filter(cal => {
        return cal.name !== null ? cal.name.match(new RegExp(this.search, 'i')) : ''
      })
    },
    isSchoolSFOActive () {
      return this.$store.getters.isSchoolSFOActive
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    }
  },
  methods: {
    goToDutySchedule () {
      window.location.href = '/schools/' + this.schoolId + '/duty_schedule'
    },
    getSchoolCalendars () {
      if (!this.schoolId) {
        return
      }
      if (this.isSchoolTestingStudents) {
        this.$store.dispatch('readCalendarRelations')
      }
      this.$store.dispatch('getSchoolCalendars', this.schoolId)
      this.$store.dispatch('readSchoolYears', this.schoolId)
    },
    getCalStudents (calStudents) {
      const students = calStudents.filter(studentId => this.allCalendarsInHash[studentId] && !this.allCalendarsInHash[studentId].archived_at).map(studentId => this.allCalendarsInHash[studentId])
      return this.$helpers.sortArrOnName(students)
    },
    setActiveCalendarId (calId) {
      if (window.location.href.indexOf('calendar') < 0 || window.location.href.indexOf('?tasks') > 0) {
        window.location.href = '/calendar/?cal=' + calId
      }
      this.$store.commit('setActiveCalendarId', calId)
      this.closeSideNav()
    },
    setTheStudentsActiveForCal (calId) {
      if (this.isStudentsActiveForCal(calId)) {
        this.theStudentsActiveForCal = null
      } else {
        this.theStudentsActiveForCal = calId
      }
    },
    isStudentsActiveForCal (calId) {
      return this.theStudentsActiveForCal === calId
    },
    userHasPermission (val) {
      if (!this.user) {
        return false
      }
      if (this.isPermissionsActivatedForSchool) {
        return this.userPermissions.indexOf(val) > -1 || this.user.admin
      } else {
        return true
      }
    },
    createKlasses () {
      eventbus.createKlassModal = true
      eventbus.showOnboardingArrow = false
    },
    createUsers () {
      eventbus.createUserModal = true
      eventbus.showOnboardingArrow = false
    },
    createCalendars (calendarType) {
      eventbus.createCalendarsType = calendarType
      eventbus.showOnboardingArrow = false
    },
    toggleChangeSchoolDropdown () {
      this.changeSchoolDropdown = !this.changeSchoolDropdown
    },
    openSideNav (cals) {
      if (this.open) {
        return
      }
      this.open = true
      var pagewidth = document.getElementById('djs-content-container')
      if (!pagewidth.classList.contains('djs_menu_out')) {
        pagewidth.className += ' djs_menu_out'
      }
      if (cals === 0) {
        this.isKindergarten ? this.chooseCals(7) : this.chooseCals(1)
      }
      setTimeout(_ => {
        this.$refs.searchfield.focus()
      }, 200)
    },
    clickaway (e) {
      if (e !== undefined) {
        if (e.target.classList.toString().startsWith('lity') || e.target.classList.contains('js-setupWidgetEvent') || e.target.classList.contains('js-modalCloseEvent') || e.target.classList.contains('js-dontCloseSidenav')) {
          return
        }
      }
      if (eventbus.createModalOpen) {
        return
      }
      this.closeSideNav()
      if (this.activeOnboardingStep > 0 && this.activeOnboardingStep < 5) {
        this.$store.commit('setOnboardingStep', 0)
      }
      if (this.activeOnboardingStep === 6) {
        this.$store.commit('setOnboardingStep', 0)
      }
    },
    closeSideNav () {
      this.open = false
      var pagewidth = document.getElementById('djs-content-container')
      if (this.hasClass(pagewidth, 'djs_menu_out')) {
        pagewidth.className = 'content_container'
        this.active = ''
      }
    },
    clearSearch () {
      this.search = ''
    },
    // filter options
    chooseCals (num) {
      const searchfield = document.getElementById('searchfield')
      if (searchfield !== null) {
        searchfield.focus()
      }
      let calendar = this.calendarData[num]
      this.type = calendar.type
      this.active = num
      this.searchName = calendar.searchName.toLowerCase()
    },
    isActive (num) {
      return this.active === num
    },
    hasClass (elem, cls) {
      return (' ' + elem.className + ' ').indexOf(' ' + cls + ' ') > -1
    },
    setActiveSchool () {
      let activeSchool = ''
      // if user selects a school
      if (this.user.current_school) {
        activeSchool = this.user.current_school
        // if user has a primary school
      } else if (this.user.primary_school) {
        activeSchool = this.user.primary_school
      } else {
        // if user only has 1 school or no primary
        activeSchool = this.user.schools[0]
      }
      // this.$store.commit('setActiveSchool', activeSchool)
      this.$store.dispatch('readActiveSchool', activeSchool)
    },
    manipulateSchoolStuffForKindergarten () {
      const elSupportLink = document.querySelector('.js-intro-support__nav > a')
      if (elSupportLink) {
        elSupportLink.setAttribute('href', 'https://app.docendo.dk/features/daycare/')
      }
      this.changeLinksTextString('Opgaveoversigt', 'Årsnormsoversigt')
      this.changeLinksTextString('Feriekalender', 'Lukkedage')
      this.changeLinksTextString('Skoleår', 'Perioder')
      this.changeDivTextString('Undervisere', 'Personale')
      this.changePlanningLink()
    },
    changePlanningLink () {
      // change planning link to årsnorm
      const planningLink = document.querySelector('.js-onboarding-arrow-planning > a')
      const subPlanningLink = document.querySelector('.js-onboarding-arrow-planning > .header-nav__item__dropdown > a:first-child')
      if (!planningLink || !subPlanningLink) {
        return
      }
      planningLink.setAttribute('href', '/schools/' + this.schoolId + '/annual_norm')
      planningLink.innerHTML = '<span class="icon-calendar2"></span> Årsnorm'
      subPlanningLink.remove()
    },
    changeDivTextString (initialText, newText) {
      let aElements = document.querySelectorAll('div')
      for (let i = 0; i < aElements.length; i++) {
        let a = aElements[i]
        if (a.textContent.indexOf(initialText) !== -1) {
          a.innerText = newText
        }
      }
    },
    changeLinksTextString (initialText, newText) {
      let aElements = document.querySelectorAll('a')
      for (let i = 0; i < aElements.length; i++) {
        let a = aElements[i]
        if (a.textContent.indexOf(initialText) !== -1) {
          a.innerText = newText
        }
      }
    },
    manipulateFullCalendarForRotatingSchedules (numberOfDays) {
      /*eslint-disable */
      window.addEventListener('fullcal_view_or_date_changed', e => {
        // eslint-disable-next-line no-use-before-define
        if ($) {
          const el = $('.calendar')
          const currentDate = el.fullCalendar('getDate')
          /*eslint-enable */
          let startDate = this.schoolYearStartDate
          const dataSpan = document.querySelector('#js-data-cal-date')
          if (!dataSpan && !startDate) {
            return
          }
          if (dataSpan) {
            startDate = dataSpan.getAttribute('data-cal_start_date')
          }
          const currentWeek = moment(currentDate).isoWeek()
          const startWeek = moment(startDate).isoWeek()
          if (currentWeek === startWeek - 1) {
            if (!el.data('is_master_schedule')) {
              el.data('is_master_schedule', true)
              if (numberOfDays === 6) {
                const options = {view_state: 'weekends', hiddenDays: [0]}
                calItFormROR(el, moment(currentDate).add(1, 'days'), options)
              }
              changeFullCalendarDayCellNames()
            }
          } else {
            if (el.data('is_master_schedule')) {
              el.data('is_master_schedule', false)
              if (numberOfDays === 6) {
                const options = {view_state: 'weekends', hiddenDays: []}
                calItFormROR(el, currentDate, options)
              }
            }
          }
        }
      })

      function calItFormROR (el, date, options) {
        /*eslint-disable */
        el.fullCalendar('destroy')
        cal_it(el, date, options)
        /* eslint-enable */
      }

      function changeFullCalendarDayCellNames () {
        let cells = document.querySelectorAll('th[data-date]')
        cells.forEach(function (cell) {
          let date = cell.getAttribute('data-date')
          let isoWeekday = moment(date, 'YYYY-MM-DD').isoWeekday()
          cell.textContent = 'Day ' + isoWeekday
        })
      }
    }
  },
  beforeMount () {
    this.$store.dispatch('getUser')
  },
  mounted () {
    if (this.isKindergarten) {
      this.manipulateSchoolStuffForKindergarten()
    }
    // Testing rotatingSchedules
    if (!this.schoolId) {
      return
    }
    var schoolId = this.schoolId * 1
    if (schoolId === 56541) {
      this.manipulateFullCalendarForRotatingSchedules(6)
    }
    if (schoolId === 3 || schoolId === 51097) {
      this.manipulateFullCalendarForRotatingSchedules(5)
    }
  }
}
</script>

<style>
@import ".././assets/css/variables.css";

.sidebar-nav {
  background-color: var(--dark-blue);
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  min-height: 100%;
  width: 65px;
  z-index: 810;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.sidebar-nav ul {
  flex: 1;
  margin-top: 75px;
}

.sidebar-nav li {
  color: #ffffff;
  text-align: center;
  width: 100%;
  border-left: 2px solid transparent;
  padding: 12px 0;
  border-right: 2px solid transparent;
  margin: 0;
  font-size: 10px;
  line-height: 12px;
  cursor: pointer;
  box-sizing: border-box;
  -webkit-transition: 0.1s;
  transition: 0.1s;
}

.sidebar-nav li.active {
  border-left: 2px solid #468AD7;
  background: rgba(255, 255, 255, 0.1);
}

.sidebar-nav li:hover {
  background: rgba(255, 255, 255, 0.1);
}

.sidebar-nav li .icons {
  font-size: 18px;
  margin-bottom: 10px;
}

.sidebar-nav__container {
  background-color: var(--dark-blue);
  margin: 0;
  position: fixed;
  top: 0;
  left: 65px;
  min-height: 100%;
  max-height: 100vh;
  width: 200px;
  z-index: 200;
  will-change: transform;
  transition: transform .2s ease-in-out, margin .2s ease-in-out;
  transform: translateX(-102%);
}

.sidebar-nav__container__body {
  position: relative;
  max-height: calc(100vh - 186px);
  overflow-y: auto;
}

.sidebar-nav__container__body li a, .list-search__body li a {
  color: #ffffff;
  width: 100%;
  box-sizing: border-box;
  display: block;
  padding: 2px 15px;
}

.sidebar-nav__container__body li a:hover, .list-search__body li a:hover {
  background: rgba(255, 255, 255, 0.1);
}

.sidebar-nav__container.sidebar_nav_container_show {
  transform: none;
}

.sidebar-nav__container__header {
  height: 55px;
  width: 100%;
  position: relative;
  background: var(--blue);
}

.sidebar-nav__container__header h2 {
  color: white;
  padding-left: 15px;
  font-size: 1.1em;
}

.arrow-dropdown {
  font-size: 1.5em;
  position: absolute;
  top: 15px;
  cursor: pointer;
  height: 25px;
  color: white;
  line-height: 25px;
  text-align: center;
  right: 5px;
  width: 25px;
  border-radius: 50%;
}

.sidebar-nav__container--dropdown {
  top: 55px;
  right: 0;
}

.arrow-dropdown.active {
  transform: rotate(180deg);
  transition: 0.1s;
}

.search-wrapper, .sidebar-nav__search {
  position: relative;
  padding: 15px;
}

.sidebar-nav__search__cross {
  position: absolute;
  top: 25px;
  right: 22px;
  cursor: pointer;
}

.search-wrapper__search, .sidebar-nav__search input {
  border-radius: 3px;
  background: white;
  color: var(--dark-blue);
}

.sidebar-nav__search input:focus {
  background: white;
}

.docendo-logo {
  float: left;
  box-sizing: border-box;
  width: 65px;
  height: 55px;
  background: var(--blue);
  color: white;
  cursor: pointer;
  position: relative;
  z-index: 10000;
  text-align: center;
}

.docendo-logo.docendo-logo__not-active {
  cursor: default;
}

.docendo-logo__icon {
  font-size: 45px;
  width: 100%;
  height: 100%;
  padding-top: 5px;
  display: block;
}

.switch-container {
  margin: 10px 15px -5px;
}

.create-cal__button {
  width: calc(100% - 30px);
  margin: 15px 15px 0 15px;
  cursor: pointer;
  display: block;
  text-align: center;
  padding: 2px 10px;
  font-weight: bold !important;
  height: 28px;
  border-radius: 4px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, .1);
  background-color: var(--blue);
  color: white !important;
  border: 1px solid #4e80b7 !important;
  transition: background-color 0.3s, transform 0.3s;
  transform: scale(1);
}

.create-cal__button:hover {
  background-color: #66a1e4;
}

.create-cal__button:active {
  transform: scale(0.98)
}

.no-cals {
  display: flex;
  align-items: center;
  margin: 15px;
  flex-direction: column;
  color: white;
  margin-top: 75px;
}

.no-cals__icon {
  font-size: 50px;
  border-radius: 50%;
}

.no-cals__text {
  font-style: italic;
  text-align: center;
  margin-top: 20px;
}

.nav__cal-list {
  padding-bottom: 30px;
}

.no-cals__text a {
  color: var(--blue) !important;
}

.no-cals__text a:hover {
  text-decoration: underline;
}

.nav__cal-list__item {
  display: flex;
  align-items: center;
}

.nav__cal-list__item:hover > div,
.nav__cal-list__item.nav__cal-list__item--open > div {
  background-color: rgba(255, 255, 255, .1);
}

.sidebar-nav__container__body li .nav__cal-list__item:hover a,
.nav__cal-list__item.nav__cal-list__item--open > a {
  background-color: rgba(255, 255, 255, .2);
}

.nav__cal-list__item > div {
  color: #ffffff;
  padding: 0.25rem 0.65rem;
  font-size: 1.2rem;
  height: 28px;
  width: 28px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav__cal-list__item > div > span {
  display: block;
  transform: rotate(270deg);
  transition: transform 0.25s;
}

.nav__cal-list__item.nav__cal-list__item--open > div > span {
  transform: rotate(360deg);
}

.sidebar-nav__container__body li .nav__cal-list__item a,
.list-search__body li .nav__cal-list__item a {
  padding: 0.25rem 0.5rem 0.25rem 15px;
}

.nav__cal-list__item__students {
  color: #ffffff;
  background-color: rgba(255, 255, 255, .1);
  margin: 0;
}

.nav__cal-list__item__students li {
  user-select: none;
}

.nav__cal-list__item__students li > a {
  padding: 2px 0 2px 20px;
}

.lowercase {
  text-transform: lowercase;
}
</style>



// WEBPACK FOOTER //
// SideNav.vue?199a2c04